/**
 * API методы для работы с записями на приём
 * Дата: 30.01.2026 - Создан для TODO-046 (Страница записей)
 * Связан с: internal/handler/appointment.go, frontend/src/pages/Appointments.tsx
 */
import { apiClient } from './client';

// Типы для записей на приём
export interface AppointmentDTO {
  id: string;
  external_id: string;
  phone: string;
  patient_name?: string;
  doctor_name?: string;
  appointment_datetime: string;
  status: string;
  status_display: string;
  service_name?: string;
  clinic_name?: string;
  reminder_24h_sent: boolean;
  reminder_2h_sent: boolean;
  feedback_sent: boolean;
}

export interface AppointmentFilters {
  tenant_id?: string;
  from_date?: string; // YYYY-MM-DD
  to_date?: string; // YYYY-MM-DD
  status?: string; // all, scheduled, confirmed, completed, cancelled, no_show, unknown
  search?: string; // Поиск по ФИО или телефону
  limit?: number;
  offset?: number;
}

export interface AppointmentsListResponse {
  appointments: AppointmentDTO[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
  };
}

export const appointmentsApi = {
  // Список записей с фильтрацией
  list: async (filters: AppointmentFilters = {}): Promise<AppointmentsListResponse> => {
    const params: Record<string, string> = {};
    if (filters.tenant_id) params.tenant_id = filters.tenant_id;
    if (filters.from_date) params.from_date = filters.from_date;
    if (filters.to_date) params.to_date = filters.to_date;
    if (filters.status && filters.status !== 'all') params.status = filters.status;
    if (filters.search) params.search = filters.search;
    if (filters.limit !== undefined) params.limit = String(filters.limit);
    if (filters.offset !== undefined) params.offset = String(filters.offset);

    const response = await apiClient.get<AppointmentsListResponse>('/appointments', { params });
    return response.data;
  },

  // Получить записи по телефону пациента
  getByPhone: async (phone: string, tenantId?: string, limit?: number): Promise<{ appointments: AppointmentDTO[] }> => {
    const params: Record<string, string> = {};
    if (tenantId) params.tenant_id = tenantId;
    if (limit !== undefined) params.limit = String(limit);

    const response = await apiClient.get<{ appointments: AppointmentDTO[] }>(`/appointments/by-phone/${encodeURIComponent(phone)}`, { params });
    return response.data;
  },
};
